import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Helmet } from "react-helmet";
import "../../scss/v2/legal.scss"

function Subscription(props) {

    const { t, i18n } = useTranslation();
    const [product, setProduct] = useState({});


    useEffect(() => {
        if (props.products[0] && !product.id) setProduct(props.products[0])
        i18n.changeLanguage(props.lang);
    }, [i18n, props, product.id])

    return (
        <div className="legal container">
            <Helmet>
                <title>{t("meta.title.subscription")}</title>
                <meta name="description" content={t("meta.description.subscription")} />
                <meta name="robots" content="noindex" />
            </Helmet>
            <h1 className="legal-title">{t('legal.subscription.title')}</h1>
            <div className="legal-text" dangerouslySetInnerHTML={{ __html: t('legal.subscription.text', { acqPrice: product.acqPrice, subPrice: product.subPrice, currency: product.currency, currencyCode: product.currencyCode }) }}  />
        </div>
    )

}

const mapStateToProps = state => ({ products: state.product.products });

export default connect(mapStateToProps, null)(Subscription);